import { JSX, ReactNode } from 'react';

import OnboardingTip from '@rio-cloud/rio-uikit/OnboardingTip';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { Tips } from './types';
import { Placement } from '@rio-cloud/rio-uikit/values/Placement';
import useLocalStorage from '@rio-cloud/rio-uikit/useLocalStorage';

interface OnboardingTipWrapperProps {
    tipType: Tips;
    titleTranslationId: string;
    contentTranslationId: string;
    children: ReactNode;
    className?: string;
    placement?: Placement;
}

const STORAGE_PREFIX = 'drivingtime';

export const OnboardingTipWrapper = (props: OnboardingTipWrapperProps & WrappedComponentProps): JSX.Element => {
    const {
        children,
        intl,
        tipType,
        titleTranslationId,
        contentTranslationId,
        className = 'max-width-200',
        placement = 'bottom',
    } = props;

    const toolTipStorageKey = `${STORAGE_PREFIX}.${tipType}`;
    const [toolTipSeen, setToolTipSeen] = useLocalStorage<boolean>(toolTipStorageKey, false);

    const onHide = () => {
        setToolTipSeen(true);
    };

    return (
        <OnboardingTip
            show={!toolTipSeen}
            placement={placement}
            title={intl.formatMessage({ id: titleTranslationId })}
            content={intl.formatMessage({ id: contentTranslationId })}
            className={className}
            onHide={onHide}
        >
            {children}
        </OnboardingTip>
    );
};

export const ConnectedOnboardingTip = injectIntl(OnboardingTipWrapper);
